export const documentsSelector = (state) => state.news.documents;

export const galleriesSelector = (state) => state.news.galleries;

export const galleryByIdSelector = (id) => (state) => state.news.galleries.find((gallery) => gallery.id === id);
